import { RatingDesignTokens } from '@primeuix/themes/types/rating';
import componentCommon from '../one-ds-tokens/OneDS-Component-Common.json';
import { t } from '../token-utils';

// https://github.com/primefaces/primeuix/blob/main/packages/themes/src/presets/aura/rating/index.ts
const rat = componentCommon.rating;

export const RatingTelekomDT: RatingDesignTokens = {
  root: {
    gap: t(rat.gap),
    focusRing: {
      width: t(rat.focus.ring.width),
      color: t(rat.focus.ring.color),
      offset: t(rat.focus.ring.offset),
    },
  },
  icon: {
    size: t(rat.icon.size),
    color: t(rat.icon.color),
    hoverColor: t(rat.icon.hover.color),
    activeColor: t(rat.icon.active.color),
  },
};
